import React from "react";
import { Dropdown, Icon } from "semantic-ui-react";
import { IntlContextConsumer, changeLocale, useIntl } from "gatsby-plugin-intl";

const languages = [
  { value: "en", text: "English" },
  { value: "zh", text: "中文(简体)" },
  { value: "zh-tw", text: "中文(繁體)" },
  { value: "de", text: "Deutsch" },
  { value: "es", text: "Español" },
  { value: "ru", text: "русский" },
  { value: "fr", text: "Français" },
  { value: "it", text: "Italiano" },
  { value: "pt", text: "Português" },
  { value: "nl", text: "Nederlands" },
  { value: "pl", text: "Polski" },
  { value: "da", text: "Dansk" },
  { value: "sv", text: "Svenska" },
  { value: "no", text: "norsk" },
  { value: "fa", text: "فارسی" },
  { value: "el", text: "ελληνικά" },
  { value: "ja", text: "日本語" },
  { value: "ko", text: "한국어" },
];

const LanguageSelect = () => {
  const intl = useIntl();
  const handleChange = (language) => (event, data) => {
    if (data.value === language) {
      return;
    }

    changeLocale(data.value);

    // if (process.env.GATSBY_KOREAN === "true") {
    //   if (data.value === "ko") {
    //     window.location.href = "https://picpick.net";
    //   } else {
    //     window.location.href = `https://picpick.app/${data.value}`;
    //   }
    // } else {
    //   changeLocale(data.value);
    // }
  };

  return (
    <IntlContextConsumer>
      {({ language }) => {
        const languageName = languages.find(
          (item) => item.value === language
        ).text;
        return (
          <Dropdown
            trigger={
              <span>
                <Icon name="world" /> {languageName}
              </span>
            }
            floating
            scrolling
            value={language}
            onChange={handleChange(language)}
            options={languages}
          />
        );
      }}
    </IntlContextConsumer>
  );
};

export default LanguageSelect;
